<template>
  <div
    class="ui-default-view"
    :class="{'collapsed-side-nav': collapseSideNav}"
  >
    <SideNav
      :collapsed="collapseSideNav"
      @onExpand="collapseSideNav = false"
      @onCollapse="collapseSideNav = true"
    />
    <router-view />
  </div>
</template>

<script>
import SideNav from '@frontend/ui/components/global/SideNav.vue';

const STORAGE_KEY = 'UIShowSidenav';

export default {
  name: 'DefaultView',
  components: {
    SideNav,
  },
  data() {
    return {
      collapseSideNav: false, // Default: side nav is visible
    };
  },
  watch: {
    collapseSideNav(newVal) {
      if (newVal) {
        localStorage.setItem(STORAGE_KEY, 'true');
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    },
  },
  created() {
    const storedState = localStorage.getItem(STORAGE_KEY);

    // Convert string to boolean
    if (storedState !== null) {
      this.collapseSideNav = storedState === 'true';
    }
  },
  methods: {
    // Optional manual save
    saveHideSideNav() {
      localStorage.setItem(STORAGE_KEY, this.collapseSideNav);
    },
    clearHideSideNav() {
      this.collapseSideNav = false;
      localStorage.removeItem(STORAGE_KEY);
    },
  },
};
</script>

<style scoped>
.ui-default-view {
  display: grid;
  min-height: 100vh;
  grid-template-columns: var(--stk-sidenav-width) 1fr;
  align-items: stretch;
  transition-duration: var(--stk-transition-duration);
  transition-property: grid-template-columns;

  &.collapsed-side-nav {
    grid-template-columns: var(--stk-sidenav-collapsed-width) 1fr;
  }
}
</style>
